import { Observable } from 'rxjs';
import { PatchOrganisationConfiguration } from './config-all.model';

export abstract class ConfigAllService {
    abstract patchOrganisationConfiguration(body: PatchOrganisationConfiguration, orgTag: string): Observable<any>;
    abstract getOrganisationConfiguration(tag: string): Observable<any>;
    abstract getAllCoreConfig(): Observable<any>;
}
